import RefreshIcon from '@atlaskit/icon/core/refresh';
import * as React from 'react';

export function SvgRefresh() {
  return <RefreshIcon label="" testId="ads-refreshed-icon" />;
}
